<div class="imageSide bg-helper-two relative flex h-full w-full flex-col items-center justify-center p-5">
  <button
    (click)="toggleLanguage()"
    [class]="
      'border-primary text-primary hover-border-primary hover-bg-primary absolute top-6 flex h-9 cursor-pointer items-center justify-center gap-2 rounded-lg border-2 bg-white px-4 py-2 transition-all hover:text-white active:scale-95' +
      (currentLocale() === 'en' ? ' left-6' : currentLocale() === 'ar' ? ' right-6' : '')
    ">
    <svg class="h-4 w-4 transition-colors" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path d="M2 12H22" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22C9.49872 19.2616 8.07725 15.708 8 12C8.07725 8.29203 9.49872 4.73835 12 2Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
    <span class="font-['Inter'] text-sm font-medium whitespace-nowrap transition-colors">
      {{ currentLocale() == "en" ? "العربية" : "English" }}
    </span>
  </button>

  <div class="flex flex-col items-center">
    <img [src]="imageSrc()" alt="Pharma Logo" class="my-2 w-1/2" />
  </div>
  <div class="mt-6 pb-5">
    <h1 class="textPrimaryColor text-center text-[32px] font-bold">
      @if (type() === "register") {
        <span i18n="@@registerWelcomeTitle">{{ title() }}</span>
      }
      @if (type() === "login") {
        <span i18n="@@loginWelcomeBack">{{ title() }}</span>
      }
    </h1>
    <p class="mt-2 w-[345px] text-center text-[20px] font-extralight">
      @if (type() === "register") {
        <span i18n="@@registerWelcomeDescription">{{ description() }}</span>
      }
      @if (type() === "login") {
        <span i18n="@@loginWelcomeDescription">{{ description() }}</span>
      }
    </p>
  </div>
</div>
